var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('p', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [!_vm.missions ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label field--required"
  }, [_vm._v("分店代碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "field__input",
    attrs: {
      "placeholder": "請輸入分店代碼",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  }), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("請輸入您的分店代碼以產生各任務 QR Code")])]), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-mt-3",
    attrs: {
      "disabled": _vm.loading || !_vm.branchCode
    },
    on: {
      "click": _vm.fetchAllMissionsTokens
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? '產生中...' : '產生 QR Code') + " ")])], 1) : _c('div', {
    staticClass: "missions"
  }, [_vm._l(_vm.missions, function (mission) {
    return _c('div', {
      key: mission.id,
      staticClass: "mission-item"
    }, [_c('div', {
      staticClass: "mission-item__header",
      on: {
        "click": function click($event) {
          return _vm.toggleMission(mission.id);
        }
      }
    }, [_c('span', {
      staticClass: "mission-item__title"
    }, [_vm._v(_vm._s(mission.title))]), _c('span', {
      staticClass: "mdi",
      class: _vm.isOpen(mission.id) ? 'mdi-chevron-up' : 'mdi-chevron-down'
    })]), _vm.isOpen(mission.id) ? _c('div', {
      staticClass: "mission-item__body"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center"
    }, [_c('vue-qr', {
      attrs: {
        "text": _vm.getMissionQrUrl(mission),
        "size": 250
      }
    })], 1), mission.confirm_type === 'dynamic_verification' ? _c('div', {
      staticClass: "text-center"
    }, [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("QR Code 將在 " + _vm._s(_vm.countdown) + " 秒後自動更新")])]) : _vm._e()]) : _vm._e()]);
  }), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-mt-3",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" 重新輸入分店代碼 ")])], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }